import {
  type RouteObject,
} from "react-router";
import TrainListApp from "train/list/app";

declare let viewModel: any;

export const trainRoute: RouteObject = {
  path: "train",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: TrainListApp,
  }]
};